import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(updateLocale);
dayjs.updateLocale('en', { weekStart: 1 });

let currentTimezone = "Australia/Sydney";

export const setDefaultTimezone = (tz) => {
  if (tz) {
    currentTimezone = tz;
  }
  dayjs.tz.setDefault(currentTimezone);
};

export const fromUtc = (value) => (value ? dayjs.utc(value).tz(currentTimezone) : null);

export const toUtcISOString = (value) => (value ? dayjs.tz(value, currentTimezone).utc().toISOString() : null);

const formatRange = (start, end) => `${start.format("D MMM YYYY")} - ${end.format("D MMM YYYY")}`;

export const getDateRangeTitles = () => {
  const today = dayjs.tz();

  // Month to Date
  const mtdStart = today.startOf("month");
  const mtdEnd = today;

  // Last Month
  const lastMonth = today.subtract(1, "month");
  const lastMonthStart = lastMonth.startOf("month");
  const lastMonthEnd = lastMonth.endOf("month");

  // Last 3 Months (Quarter)
  const lastQuarterEnd = today.subtract(1, "month").endOf("month");
  const lastQuarterStart = lastQuarterEnd.subtract(2, "month").startOf("month");

  // Last 12 Months
  const last12End = today.startOf("month").subtract(1, "day");
  const last12Start = last12End.subtract(11, "month").startOf("month");

  // Financial Year to Date (Australia)
  const ausToday = dayjs().tz("Australia/Sydney");
  const fyStartYear = ausToday.month() >= 6 ? ausToday.year() : ausToday.year() - 1;
  const fytdStart = ausToday.year(fyStartYear).month(6).date(1).startOf("day");
  const fytdEnd = ausToday;

  return {
    monthToDate: formatRange(mtdStart, mtdEnd),
    lastMonth: formatRange(lastMonthStart, lastMonthEnd),
    lastQuarter: formatRange(lastQuarterStart, lastQuarterEnd),
    last12Months: formatRange(last12Start, last12End),
    financialYearToDate: formatRange(fytdStart, fytdEnd)
  }
}

export default dayjs;